module.exports = __webpack_public_path__ + "img/f1-logo-white.5cd99da3.svg";